export default __webpack_public_path__ + "media/avatars/09-6fc3c61c.png";